export const WEEK_DAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

export const MONTHS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
]

export const viewOptions = [
  { label: 'Mês', value: 'month' },
  { label: 'Semana', value: 'week' },
  { label: 'Dia', value: 'day' },
  { label: 'Lista', value: 'list' },
]

export const tipoOptions = [
  { label: 'Negociação', value: 'NEGOCIACAO' },
  { label: 'Contato', value: 'CONTATO' },
  { label: 'Boleto', value: 'BOLETO' },
]

export const statusOptions = [
  { label: 'Agendado', value: 'AGENDADO', color: '#1a73e8', badge: 'badge-info' },
  { label: 'Pendente', value: 'PENDENTE', color: '#fbbc05', badge: 'badge-warning' },
  { label: 'Em andamento', value: 'EM_ANDAMENTO', color: '#1a73e8', badge: 'badge-info' },
  { label: 'Concluído', value: 'CONCLUIDO', color: '#34a853', badge: 'badge-success' },
  { label: 'Reagendado', value: 'REAGENDADO', color: '#f4a460', badge: 'badge-warning' },
]

export const motivoOptions = [
  { label: 'Aguardando pagamento', value: 'AGUARDANDO_PAGAMENTO', color: '#ea4335', badge: 'badge-danger' },
  { label: 'Aguardando cancelamento', value: 'AGUARDANDO_CANCELAMENTO', color: '#ea4335', badge: 'badge-danger' },
  { label: 'Acordo cancelado', value: 'ACORDO_CANCELADO', color: '#ea4335', badge: 'badge-danger' },
  { label: 'Retorno', value: 'RETORNO', color: '#ea4335', badge: 'badge-danger' },
  { label: 'Parcela vencida', value: 'PARCELA_VENCIDA', color: '#ea4335', badge: 'badge-danger' },
  { label: 'Parcela a vencer', value: 'PARCELA_A_VENCER', color: '#fbbc05', badge: 'badge-warning' },
  { label: 'Análise urgente', value: 'ANALISE_URGENTE', color: '#fbbc05', badge: 'badge-warning' },
  { label: 'Solicitação de débito', value: 'SOLICITACAO_DEBITO', color: '#fbbc05', badge: 'badge-warning' },
  { label: 'Pendência', value: 'PENDENCIA', color: '#fbbc05', badge: 'badge-warning' },
]

export const formatDateKey = date => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const isSameDay = (date1, date2) =>
  date1.getFullYear() === date2.getFullYear()
  && date1.getMonth() === date2.getMonth()
  && date1.getDate() === date2.getDate()

export const getStartOfWeek = date => {
  const d = new Date(date)
  const day = d.getDay()
  const diff = d.getDate() - day
  return new Date(d.setDate(diff))
}

export const getStatusColor = status => {
  const colors = {
    AGENDADO: '#1a73e8',
    PENDENTE: '#fbbc05',
    EM_ANDAMENTO: '#1a73e8',
    CONCLUIDO: '#34a853',
    REAGENDADO: '#f4a460',
  }
  return colors[(status || '').toUpperCase()] || '#5f6368'
}

export const getMotivoColor = motivo => {
  const option = motivoOptions.find(o => o.value === (motivo || '').toUpperCase())
  return option ? option.color : '#5f6368'
}

export const getTipoColor = tipo => {
  const colors = {
    BOLETO: '#188038',
    CONTATO: '#1a73e8',
    NEGOCIACAO: '#a142f4',
  }
  return colors[(tipo || '').toUpperCase()] || '#5f6368'
}

export const getStatusBadgeClass = status => {
  const classes = {
    AGENDADO: 'badge-info',
    PENDENTE: 'badge-warning',
    EM_ANDAMENTO: 'badge-info',
    CONCLUIDO: 'badge-success',
    REAGENDADO: 'badge-warning',
  }
  return classes[(status || '').toUpperCase()] || 'badge-secondary'
}

export const getStatusLabel = status => {
  const option = statusOptions.find(o => o.value === (status || '').toUpperCase())
  return option ? option.label : status
}

export const getMotivoBadgeClass = motivo => {
  const option = motivoOptions.find(o => o.value === (motivo || '').toUpperCase())
  return option ? option.badge : 'badge-secondary'
}

export const getMotivoLabel = motivo => {
  const option = motivoOptions.find(o => o.value === (motivo || '').toUpperCase())
  return option ? option.label : motivo
}

export const formatHour = hour => `${String(hour).padStart(2, '0')}:00`

export const formatCliente = cliente => {
  if (!cliente) return ''
  if (typeof cliente === 'object') return cliente.nome || cliente.name || ''
  return String(cliente)
}

export const formatFullDate = date => {
  const dayNames = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
  return `${dayNames[date.getDay()]}, ${date.getDate()} de ${MONTHS[date.getMonth()]}`
}

export const formatDateTimeForPicker = date => {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`
}

export const parseDateFromPicker = dateStr => {
  if (!dateStr) return null
  try {
    const brMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{1,2}))?$/)
    if (brMatch) {
      const [, d, m, y, h = '0', min = '0'] = brMatch
      return new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10), parseInt(h, 10), parseInt(min, 10))
    }
    const date = new Date(dateStr)
    return Number.isNaN(date.getTime()) ? null : date
  } catch {
    return null
  }
}

export const formatEventTime = dateStr => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return ''
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

export const formatDateTime = dateStr => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return ''
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month} ${hours}:${minutes}`
}

export const hours = Array.from({ length: 24 }, (_, i) => i)
